import React from "react";
import { map, get, compact } from "lodash";
import { useLocomotiveContext } from "@providers/LocomotiveProvider";
import cx from "classnames";
import styles from "./TableContent.module.scss";

const View = ({ data }: any) => {
  const { scroll } = useLocomotiveContext();
  // const [collapse, $collapse] = React.useState(false);
  const handle = {
    onClick: (e: any) => {
      const to = get(e, "target.dataset.className");
      const element = document.querySelector(`.${to}`);
      if (!!to) {
        scroll.scrollTo(element, { offset: -84, duration: 200 });
      }
    },
  };
  return (
    <div className={styles.section}>
      <div className={cx(styles.table)}>
        {compact(
          map(
            data,
            (item, index) =>
              !!get(item, "titleTableOfContent") && (
                <h6
                  key={`toc_${index}`}
                  data-class-name={get(item, "className")}
                  onClick={handle.onClick}
                >
                  {get(item, "titleTableOfContent")}
                </h6>
              )
          )
        )}
      </div>
    </div>
  );
};
export default View;
